var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToyota(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Toyota",
    xmlns: "http://www.w3.org/2000/svg",
    width: 549.553,
    height: 90.406,
    viewBox: "0 0 549.553 90.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89934",
    "data-name": "Path 89934",
    d: "M65.039,85.806C57.763,81.248,52.4,65.519,52.4,46.832c0-.686,0-1.362.02-2.037h0l.009.01h0C32.192,41.623,17.569,32.909,17.195,22.6h0l-.059.119h0A33.086,33.086,0,0,0,9.357,43.575c0,22.31,24.489,40.589,55.552,42.206h0l.131.025ZM0,45.2C0,20.24,31.065,0,69.388,0s69.388,20.24,69.388,45.2-31.066,45.2-69.388,45.2S0,70.165,0,45.2ZM69.388,6.524c7.4,0,13.691,11.222,16.022,26.881h0l.009-.024h0c14.392-2.24,24.47-7.408,24.47-13.422,0-8.072-18.135-14.607-40.5-14.607s-40.5,6.536-40.5,14.607c0,6.014,10.076,11.182,24.47,13.422h0l.009.024h0C55.7,17.746,61.992,6.524,69.388,6.524Zm4.479,79.257c31.062-1.616,55.555-19.9,55.555-42.206a33.094,33.094,0,0,0-7.781-20.851h0l-.06-.119h0c-.374,10.3-14.993,19.018-35.234,22.2h0l.009-.01h0c.014.676.021,1.352.021,2.037,0,18.688-5.364,34.417-12.637,38.974h0l.128-.025ZM69.388,34.568c3.314,0,6.536-.141,9.619-.413h0l0,0h0c-1.534-10.038-5.261-17.122-9.615-17.122s-8.08,7.084-9.616,17.122h0l0,0h0c3.083.272,6.306.413,9.62.413Zm0,37.171c5.57,0,10.113-11.591,10.355-26.128h0l.03.01h0c-3.357.311-6.83.473-10.385.473S62.361,45.932,59,45.621h0l.031-.01h0c.239,14.537,4.781,26.128,10.353,26.128Z",
    fill: "#e2001a",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89935",
    "data-name": "Path 89935",
    d: "M643.849,53.923A34.55,34.55,0,1,1,678.4,88.471a34.55,34.55,0,0,1-34.546-34.548ZM678.4,75.8c10.657,0,19.295-9.8,19.295-21.88s-8.638-21.88-19.295-21.88-19.286,9.8-19.286,21.88S667.746,75.8,678.4,75.8Z",
    transform: "translate(-289.785 -8.72)",
    fill: "#e2001a",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89936",
    "data-name": "Path 89936",
    d: "M812.253,35.719V88.852H797.7V35.719H777.388V23.707h55.171V35.719H812.253Z",
    transform: "translate(-349.889 -10.67)",
    fill: "#e2001a",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89937",
    "data-name": "Path 89937",
    d: "M891.241,74.194l-.014.014-5.584,14.644h-17L895.52,23.706h18.115l26.879,65.146h-17l-5.584-14.644-.014-.014H891.241Zm13.34-11h9.158l-.005,0-9.09-23.844h-.128l-9.1,23.844,0,0Z",
    transform: "translate(-390.961 -10.67)",
    fill: "#e2001a",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89938",
    "data-name": "Path 89938",
    d: "M324.308,35.719V88.852H309.751V35.719H289.442V23.707h55.173V35.719H324.308Z",
    transform: "translate(-130.273 -10.67)",
    fill: "#e2001a",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89939",
    "data-name": "Path 89939",
    d: "M396.541,53.923a34.551,34.551,0,1,1,34.552,34.548,34.551,34.551,0,0,1-34.552-34.548ZM431.093,75.8c10.651,0,19.29-9.8,19.29-21.88s-8.638-21.88-19.29-21.88-19.292,9.8-19.292,21.88S420.44,75.8,431.093,75.8Z",
    transform: "translate(-178.476 -8.72)",
    fill: "#e2001a",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89940",
    "data-name": "Path 89940",
    d: "M556.2,88.852h7.381V64.115l25.395-40.408h-17L556.2,51.089,540.419,23.707h-17l25.4,40.408V88.852Z",
    transform: "translate(-235.581 -10.67)",
    fill: "#e2001a",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyota);
export default __webpack_public_path__ + "static/media/Toyota.018b1767d53f3c01a5f36281ef676d9e.svg";
export { ForwardRef as ReactComponent };